export const leadForm: object = {
  leadForm: {
    options: {
      receiveMarketingCommunications: 'Ja, ich möchte Marketingmitteilungen von SAP erhalten',
      createAccountAndSaveDetails: 'Konto erstellen und meine Daten speichern',
      alreadyHaveAnAccount: 'Sie haben bereits einen Account?',
      loggedInAs: 'Angemeldet als',
      logIn: 'Log In',
      logOut: 'Ausloggen',
    },
    fields: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'Email',
      firstNameEmployee: 'Vorname (Optional)',
      lastNameEmployee: 'Nachname (Optional)',
      emailEmployee: 'Email (Optional)',
      phone: {
        phoneNumber: 'Telefonnummer (Optional)',
        phoneTooltip: 'Durch Angabe einer Telefonnummer kann der Herausgeber offene Fragen einfacher direkt mit Ihnen klären'
      },
      street: {
        streetAddress: 'Adresse (Optional)',
        streetTooltip: 'Angabe einer Adresse hilft uns Ihr Unternehmen sicherer zu identifizieren',
      },
      companyName: 'Firmenname',
      country: 'Land',
      city: 'Stadt',
      region: 'Bundesland/Region',
      postalCode: 'Postleitzahl',
      message: 'Nachricht (Optional)',
      customerId: 'Unternehmen CRM ID',
      expectedTotalValue: {
        label: 'SAP-Gesamtwert der Umsatzbeteiligung',
        tooltipContent: 'Bitte geben Sie als Durchschnittswert 10.000 EUR ein, falls Sie diesen noch nicht kennen. Sie können Harmony bei Bedarf mit diesen Informationen aktualisieren.'
      },
      currency: 'Währung',
      expectedStartDate: 'Erwartetes Startdatum',
      expectedEndDate: 'Erwartetes Enddatum',
    },
    sections: {
      companyDetails: 'Angaben zum Unternehmen',
      personalDetails: 'Persönliche Angaben',
      productIcon: 'Produktsymbol',
      partnerIcon: 'Partnersymbol',
      yourDerails: 'Deine Details',
      customerDetails: 'Kundendetails',
      contractDetails: 'Vertragsdetails',
    },
    success: {
      formSubmitted: 'Ihre Nachricht wurde übermittelt',
      nextAction: 'wird in den nächsten zwei Geschäftstagen mit Ihnen in Kontakt treten.',
      freeTrialIsReady: 'Dankeschön! Ihre kostenlose Testversion ist bereit.',
      getTrialNextAction: 'Klicken Sie unten, um zur Testzugriffsseite zu gelangen.',
      getTrial: 'Zur Testversion',
    },
    errors: {
      invalidEmail: 'Die eingegebene E-Mail-Adresse ist nicht gültig.',
      required: 'Dies ist ein Pflichtfeld.',
      tooLong: 'Dieser Text ist zu lang.',
      internalServerError: 'Ein interner Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal oder',
      contactSupport: 'kontaktieren Sie den Support',
      employeeSAPCompany: 'Bitte identifizieren Sie einen GÜLTIGEN Endkunden oder Interessenten',
      invalidDate: 'Geben Sie ein Datum im Format ein dd-MMMM-YYYY',
      maxDate: 'Geben Sie ein Datum im Format ein dd-MMMM-YYYY',
      minDate: 'Geben Sie ein Datum im Format ein dd-MMMM-YYYY',
      startDate: 'Datum muss früher sein als {{minDate}}',
      endDate: 'Datum muss früher sein als {{maxDate}}',
      number: 'Bitte geben Sie einen numerischen Wert mit maximal 2 Dezimalstellen ein.',
    },
    cta: {
      trial: 'Testversion Anfordern',
      buy: 'Wenden Sie sich an den Vertrieb',
      rfi: 'Nachricht Senden'
    },
    userInfo: {
      name: 'Name',
      phone: 'Telefon'
    },
    customerDetails: 'Hier können Sie zusätzliche Kundendaten zur korrekten Kundenidentifikation angeben. Beachten Sie, dass dies vom Partner verwendet werden kann, um Ihren Kunden direkt zu kontaktieren.'
  }
};
